/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_TitleInputs */

const en_landing_guide_s3_title = /** @type {(inputs: Landing_Guide_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What people make with Ideogram AI 4.5`)
};

const zh_landing_guide_s3_title = /** @type {(inputs: Landing_Guide_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大家用 Ideogram AI 4.5 做什么`)
};

/**
* | output |
* | --- |
* | "What people make with Ideogram AI 4.5" |
*
* @param {Landing_Guide_S3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_title = /** @type {((inputs?: Landing_Guide_S3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_title(inputs)
	return zh_landing_guide_s3_title(inputs)
});
export { landing_guide_s3_title as "landing.guide.s3_title" }